import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useAppointmentContext } from '../../../pages/BookAppointment/context/AppointmentContext.js';
import { useRoutingContext } from '../../../pages/BookAppointment/context/RoutingContext/context.js';
import NoStoresAlert$1 from './NoStoresAlert.js';

const NoStoresAlertContainer = ()=>{
    const { getLabel  } = useIntl();
    const [{ setType  }] = useAppointmentContext();
    const [{ goTo  }, { queryParams  }] = useRoutingContext();
    const labels = React.useMemo(()=>({
            message: getLabel('appointments.component.storeFinder.noStoresAlert.message'),
            action: getLabel('appointments.component.storeFinder.noStoresAlert.action')
        })
    , [
        getLabel
    ]);
    const onClearAppointmentType = React.useCallback(()=>{
        setType(null);
        const newQueryParams = swcHelpers.objectSpread({}, queryParams);
        delete newQueryParams.typeId;
        goTo('where', newQueryParams);
    }, [
        queryParams,
        goTo,
        setType
    ]);
    return /*#__PURE__*/ React.createElement(NoStoresAlert$1, {
        labels: labels,
        onClearAppointmentType: onClearAppointmentType
    });
};
var NoStoresAlert = NoStoresAlertContainer;

export { NoStoresAlert as default };
//# sourceMappingURL=NoStoresAlertContainer.js.map
